import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import { currency as localiseCurrency } from '../../../../../utils/localise';

import Button from '@xanadu/ui-shared/components/widgets/Button';

import styles from '../../RgInteraction.module.scss';

const CasinoLossAuto = ({
  closeRgPopup,
  goToRgTools,
  currency,
  casinoLossesLast7Days,
  casinoLossesLastDay
}) => (
  <Fragment>
    <div>
      <div className={styles.title}>
        Time for a Quick Check-in?
      </div>
      <div>
        Part of playing smart is staying informed.
        We’ve summarised your recent Casino activity below to help you stay on top of your game.
      </div>
      <ul className={styles.list}>
        {casinoLossesLastDay !== undefined ?
          <li>{`${localiseCurrency(casinoLossesLastDay, currency, { symbol: true })} in the past 24 hours on the Casino`}</li>
          :
          null}
        {casinoLossesLast7Days !== undefined ?
          <li>{`${localiseCurrency(casinoLossesLast7Days, currency, { symbol: true })} in the past 7 days on the Casino`}</li>
          :
          null}
      </ul>
      <div>
        <span>Does your recent activity match your expectations?</span>
        <br />
        <br />
        <span>
          Take a moment to review your safety tools and ensure they’re still working best for you.
        </span>
      </div>
    </div>
    <div className={styles.containerActions}>
      <Button
        sizeType="wider"
        buttonType="flat"
        onClick={closeRgPopup}
      >
        Not Now
      </Button>
      <Button
        sizeType="wider"
        buttonType="primary"
        onClick={goToRgTools}
        className={styles.primaryButton}
      >
        Review My Settings
      </Button>
    </div>
  </Fragment>
);

CasinoLossAuto.propTypes = {
  closeRgPopup: PropTypes.func.isRequired,
  goToRgTools: PropTypes.func.isRequired,
  currency: PropTypes.string.isRequired,
  casinoLossesLastDay: PropTypes.number,
  casinoLossesLast7Days: PropTypes.number
};

export default CasinoLossAuto;

